module.exports = __webpack_public_path__ + "resources/img/reading-pen.4e1bb3c3.png";